import { CycleBoundary, CycleSymbol } from 'formwork-planner-lib'
import { UndoRedoHistory } from '../../../models/history/undoRedoHistory'
import { InteractionState } from '../../planner/types/interactionState'

export interface CycleData {
  cycleBoundaries: CycleBoundary[]
  cycleSymbols: CycleSymbol[]
}

export class CycleUndoRedoHistory extends UndoRedoHistory<CycleData> {
  deserialize(serializedValue: string): CycleData {
    const deserializedValue = JSON.parse(serializedValue) as CycleData
    return {
      cycleBoundaries: deserializedValue.cycleBoundaries,
      cycleSymbols: deserializedValue.cycleSymbols,
    }
  }

  serialize(value: CycleData): string {
    const copiedData: CycleData = {
      cycleBoundaries: value.cycleBoundaries.map((it) => ({
        id: it.id,
        cycleNumberRight: it.cycleNumberRight,
        cycleNumberLeft: it.cycleNumberLeft,
        start: { x: it.start.x, y: it.start.y },
        end: { x: it.end.x, y: it.end.y },
      })),
      cycleSymbols: value.cycleSymbols.map((it) => ({
        cycleNumber: it.cycleNumber,
        position: { x: it.position.x, y: it.position.y },
        state: InteractionState.ENABLED,
      })),
    }
    return JSON.stringify(copiedData)
  }
}
